import * as semrush from "@anm/helpers/semrush";
import { getLinkTarget, getUpgradeLinkProps } from '@anm/helpers/upgradeLink';
import { FC } from 'react';
import { useSelector } from 'react-redux';

import { userSelectors } from '../../../../../../store/modules/user';

type HintLinkProps = {
  showUpgrade?: boolean;
};

const FreeOrCreatorHint: FC = () => (
  <>
    <a {...getUpgradeLinkProps('/pricing/upgrade?period=annual&plan=Business', '_self')}>Upgrade</a> to increase this
    limit.
  </>
);

const ProOrBusinessHint: FC = () => (
  <a
    href="https://wave.video/help/articles/3348481"
    target={getLinkTarget()}
  >
    Learn more
  </a>
);

const HintLink: FC<HintLinkProps> = ({ showUpgrade }) => {
  const isUserFree = useSelector(userSelectors.selectIsUserFree);
  const isCreator = useSelector(userSelectors.selectIsUserCreator);
  const isBusiness = useSelector(userSelectors.selectIsBusinessUser);
  const isPro = useSelector(userSelectors.selectIsUserPro);
  const isSemrush = semrush.isSemrushIframe();

  const freeORCreator = isUserFree || isCreator;
  const proORBusiness = isPro || isBusiness;

  return isSemrush? null : freeORCreator && showUpgrade ? <FreeOrCreatorHint /> : proORBusiness ? <ProOrBusinessHint /> : null;
};

export default HintLink;
